import Grid from '@mui/joy/Grid'
import Typography from '@mui/joy/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { CircularProgress } from '@mui/joy'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function RewardsLoading() {
  const navigate = useNavigate()

  function goTo(route: string) {
    navigate(route)
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <Grid sx={{ pb: 2, pt: 2 }}>
        <Typography
          level="h4"
          sx={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
          onClick={() => goTo('/')}
        >
          <ArrowBackIcon />
          Vissza az üzleteimhez
        </Typography>

        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid sx={{ pb: 2, pt: 2 }}>
            <CircularProgress />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default RewardsLoading
